export default "__VITE_ASSET__C8cNRnw3__"